import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formReview_formContainer: {

		},
		formReview_statusContainer: {
			padding: theme.spacing(4, 0),
		},
		formReview_statusLabel: {
			fontSize: theme.typography.h4.fontSize,
			marginBottom: theme.spacing(3),
		},
		formReview_statusLabelDefault: {
			color: theme.palette.info.main,
		},
		formReview_statusLabelApproved: {
			color: theme.palette.success.main,
		},
		formReview_statusLabelDeclined: {
			color: theme.palette.error.main,
		},
		formReview_statusLabelHold: {
			color: theme.palette.warning.main,
		},
		formReview_statusParagraph: {
			color: theme.palette.info.main,
			marginBottom: theme.spacing(4),
		},
		formReview_statusParagraphNoBottomMargin: {
			color: theme.palette.info.main,
		},
		formReview_statusParagraphBold: {
			fontWeight: theme.typography.fontWeightBold,
		},
		formReview_link: {
			color: theme.palette.primary.main,
			textDecoration: 'none',
		},
		formReview_optionButtonsContainer: {

		},
		formReview_optionButtonsBody: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		formReview_optionButtonContainer: {
			marginRight: theme.spacing(3),
			marginBottom: theme.spacing(3),
		},
		formReview_policyNoteReason: {
			color: theme.palette.info.main,
		}
	});
});

export default useStyles;
